import React, { Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Form from 'Components/Form'
import { SelectDashboard } from 'Components/Form/SelectDashboard'

export default ({
  form,
  classes,
  handleFormChange,
  metrics,
  weekFrom,
  weekTo,
  isHideTimeRangeSelects,
}) => (
  <Box className={classes.formWrap}>
    <Form onUpdate={handleFormChange}>
      <Grid container item>
        <Grid container alignItems="center" item xs={3}>
          <Grid item>
            <Box pl={2}>
              <Typography>Metric</Typography>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <SelectDashboard
              options={metrics}
              value={form.metric}
              bgTransparent
              heightAuto
              name="metric"
            />
          </Grid>
        </Grid>

        {!isHideTimeRangeSelects && (
          <Fragment>
            <Grid container alignItems="center" item xs={3}>
              <Grid item>
                <Box pl={2}>
                  <Typography>Between</Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <SelectDashboard
                  bgTransparent
                  heightAuto
                  options={weekFrom}
                  value={form.weekFrom}
                  name="weekFrom"
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" item xs={3}>
              <Grid item>
                <Box pl={2}>
                  <Typography>To</Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <SelectDashboard
                  bgTransparent
                  heightAuto
                  options={weekTo}
                  value={form.weekTo}
                  name="weekTo"
                />
              </Grid>
            </Grid>{' '}
          </Fragment>
        )}
      </Grid>
    </Form>
  </Box>
)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/HighchartsCharts/components/ChartHeader.js